/* import __COLOCATED_TEMPLATE__ from './upload-image-action.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type ComposerPublicAPI } from '@intercom/embercom-prosemirror-composer';
import { type DisplayContext } from 'embercom/services/command-k';

interface Args {
  composerApi?: ComposerPublicAPI;
  priority?: number;
  toggleUploading?: (value: boolean) => any;
  allowedFileTypes?: string[];
  activatingComponent?: `${DisplayContext}`;
  trackingData?: Record<string, unknown>;
}

interface Signature {
  Args: Args;
}

export default class UploadImageAction extends Component<Signature> {
  @action async uploadImages(files: Array<File>) {
    try {
      this.args.toggleUploading?.(true);
      let promises: Promise<void>[] = [];

      files.reverse().forEach((file) => {
        let api = this.args.composerApi;
        if (!api) {
          return;
        }

        promises.push(api.composer.commands.insertImageFile(file));
        api.composer.commands.collapseSelection();
      });

      await Promise.all(promises);
    } finally {
      this.args.toggleUploading?.(false);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::CommandK::UploadImageAction': typeof UploadImageAction;
    'inbox2/composer/command-k/upload-image-action': typeof UploadImageAction;
  }
}
